// Shop by Purpose data with proper spiritual product images
export const purposes = [
  {
    id: 'money',
    name: 'Money & Wealth',
    description: 'Attract prosperity',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/388fdb8d20384fc187f93462814bcb9de3c7d4bd0d8bcd0e8d35ee7d170bee98.png',
    color: 'from-yellow-500/40 to-amber-600/60',
    searchQuery: 'money,wealth,pyrite,citrine,prosperity,dhan',
  },
  {
    id: 'love',
    name: 'Love & Relationships',
    description: 'Find true love',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/bbe298e1075f8cc8594bb4adc85660c824ace4db1d8b5a74882bf8a623cd87db.png',
    color: 'from-pink-500/40 to-rose-600/60',
    searchQuery: 'love,rose quartz,relationship,heart,soulmate',
  },
  {
    id: 'protection',
    name: 'Protection',
    description: 'Ward off negativity',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/e74f0db3ed95989abf6e4f0e418e3d328fe10a898cd722c4076c30444b98d753.png',
    color: 'from-slate-500/40 to-slate-700/60',
    searchQuery: 'protection,evil eye,black tourmaline,shield,nazar',
  },
  {
    id: 'career',
    name: 'Career & Success',
    description: 'Boost your career',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/6a6523a92aa22cd1e29b1e9216903af43799b9cf214e8501407335b95da43711.png',
    color: 'from-blue-500/40 to-indigo-600/60',
    searchQuery: 'career,success,tiger eye,business',
  },
  {
    id: 'health',
    name: 'Health & Wellness',
    description: 'Restore vitality',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/c6665c19bd6d4a5dd57a6c2aeb742c29a13128989a8ad64a832586063c839b04.png',
    color: 'from-emerald-500/40 to-green-600/60',
    searchQuery: 'health,wellness,healing,green aventurine',
  },
  {
    id: 'evil-eye',
    name: 'Evil Eye',
    description: 'Remove bad luck',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/2f95cc23a5982d18892f565ea77d66e8ab60884543bd9cd51cf3e844868934b7.png',
    color: 'from-cyan-500/40 to-blue-600/60',
    searchQuery: 'evil eye,nazar,protection,luck',
  },
  {
    id: 'spiritual',
    name: 'Spiritual Growth',
    description: 'Enhance spirituality',
    image: 'https://static.prod-images.emergentagent.com/jobs/d8be5d08-cdbd-415f-8a8e-77a63a782ae0/images/ca040b1f0922583e21b4728a22217cd909f863412d7ebda3a90ed5c32f8f78a2.png',
    color: 'from-purple-500/40 to-violet-600/60',
    searchQuery: 'spiritual,meditation,rudraksha,amethyst',
  },
];
